export default {
      id: "action-icon-callback-usage",
      viewBox: "0 0 30 31",
      url: __webpack_public_path__ + "icons.svg#action-icon-callback",
      toString: function () {
        return this.url;
      }
    }